import {useNavigate} from 'react-router';
import DentistAvailabilityManager from '../components/DentistAvailabilityManager';
import PageShell from '../components/PageShell';
import {useAuth} from '../hooks/AuthContext';

/** Availability management for dentists (accounts linked to a doctor record). */
const DentistAvailability = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const doctorId = auth.user && auth.user.doctor;

  if (!doctorId) {
    return (
      <PageShell title="Manage Availability" showBackButton={true}>
        <div className="container py-5">
          <div className="alert alert-danger" role="alert">
            <h4 className="alert-heading">Access Error</h4>
            <p>Access denied. This page is only available to dentists.</p>
            <hr />
            <button type="button" className="btn btn-primary" onClick={() => navigate('/')}>
              Return to Home
            </button>
          </div>
        </div>
      </PageShell>
    );
  }

  return (
    <PageShell title="Manage Availability" showBackButton={true}>
      <div className="container py-4">
        <DentistAvailabilityManager doctorId={doctorId} />
      </div>
    </PageShell>
  );
};

export default DentistAvailability;
